module.exports = "<app-header></app-header>\n<app-navigation (changeMenu)=\"activeMenu=$event\"></app-navigation>\n<app-container [title]=\"getTitle()\" [description]=\"getDescription()\"></app-container>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main